module.exports = __webpack_public_path__ + "assets/79138d3dfb334eff0f1c561034300529.svg";